export function VersionBadge() {
  const version = __APP_VERSION__

  return (
    <span className="version-badge" data-testid="version-badge" title={`Version ${version}`}>
      v{version}
    </span>
  )
}
